import { createContext, useCallback, useState } from "react";

export const topBarContext = createContext();

export const TopBarProvider = ({ children }) => {
  const [projectDetails, setProjectDetails] = useState({});

  const updateDetails = useCallback(details => {
    setProjectDetails(prev => ({
      ...prev,
      ...details
    }))
  })

  return (
    <topBarContext.Provider value={{ projectDetails, updateDetails }}>
      {children}
    </topBarContext.Provider >
  );
};  